import { render, staticRenderFns } from "./cell-action-delete.vue?vue&type=template&id=40cdc852"
import script from "./cell-action-delete.ts?vue&type=script&lang=ts&external"
export * from "./cell-action-delete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports